import PlanCategories from "@/mixins/PlanCategories";
import quoteDataReset from "../helpers/quoteDataReset";
import quoteDataRestore from "../helpers/quoteDataRestore";
import getQuotePayload from "../helpers/getQuotePayload";
import QuoteFilterPayload from "@/plugins/entities/quote/QuoteFilterPayload";

const appendSourceToUrl = (url, qtype, store) => {
  if (qtype === "trip") {
    let source = store?.getters?.source;
    if (!source && window.location.search.includes("source=")) {
      const urlParams = new URLSearchParams(window.location.search);
      source = urlParams.get("source");
      if (source && store) {
        store.commit("set_source", source);
      }
    }
    if (source) {
      return (
        url + (url.includes("?") ? `&source=${source}` : `?source=${source}`)
      );
    }
  }
  return url;
};

let resetGenBarStates = function (gBState) {
  let state = gBState.states;
  for (let screen in state) {
    state[screen] = false;
  }
};

let unbindActions = (gBState) => {
  let actions = gBState.actions;
  actions.toPrev = null;
  actions.toNext = null;
};

const quoteModule = {
  state: {
    source: null,
    bypass_restore_from_cookie: false,
    currentCategory: null,
    navigation_prev_category: null,
    navigation_next_category: null,
    showWizard: true,
    quote_data_cookie: "quoteModule.quote_data",
    quote_data_states_cookie: "quoteModule.quote_data_states",
    quote_data_expires: 60 * 60 * 12, // 12 Hours
    quote_data: {
      immigrant: {
        destination: "USA",
        destination_state: null,
        travelers: [],
        coverage_dates: {
          start_date: null,
          end_date: null,
        },
      },
      schengen: {
        destinations: [],
        travelers: [],
        coverage_dates: {
          start_date: null,
          end_date: null,
        },
      },
      student: {
        destination: null,
        destination_state: null,
        travelers: [],
        coverage_dates: {
          start_date: null,
          end_date: null,
        },
      },
      j1: {
        destination: null,
        destination_state: null,
        travelers: [],
        coverage_dates: {
          start_date: null,
          end_date: null,
        },
      },
      visitor: {
        destinations: [],
        travelers: [],
        coverage_dates: {
          start_date: null,
          end_date: null,
        },
      },
      trip: {
        destinations: [],
        travelers: [],
        coverage_dates: {
          start_date: null,
          end_date: null,
        },
        trip_deposit_date: null,
        total_trip_cost: null,
      },
      preex: {
        destinations: [],
        travelers: [],
        coverage_dates: {
          start_date: null,
          end_date: null,
        },
      },
      addnd: {
        destinations: [],
        travelers: [],
        coverage_dates: {
          start_date: null,
          end_date: null,
        },
      },
      medevac: {
        destinations: [],
        travelers: [],
        coverage_dates: {
          start_date: null,
          end_date: null,
        },
      },
      optstudent: {
        destination: "USA",
        destination_state: null,
        travelers: [],
        coverage_dates: {
          start_date: null,
          end_date: null,
        },
      },
      cruise: {
        destinations: [],
        travelers: [],
        coverage_dates: {
          start_date: null,
          end_date: null,
        },
        trip_deposit_date: null,
        total_trip_cost: null,
      },
      current_category: null,
      options: {
        skip_nav_away: false,
      },
    },
    headerLoad: {
      quote_url: null, // primarily used at /layouts/Default/Header/Buttons/PlanQuote
      toggleMobileFilter: null, // primarily used at /layouts/Default/Header/Buttons/PlanQuote
    },
    quote_results: null,
    quote_error: null,
    quote_data_states: {
      current_category: null,
      destination: {
        immigrant: {
          isValid: false,
          data: [],
        },
        schengen: {
          isValid: false,
          data: [],
        },
        student: {
          isValid: false,
          data: [],
        },
        j1: {
          isValid: false,
          data: [],
        },
        visitor: {
          isValid: false,
          data: [],
        },
        trip: {
          isValid: false,
          data: [],
        },
        preex: {
          isValid: false,
          data: [],
        },
        addnd: {
          isValid: false,
          data: [],
        },
        medevac: {
          isValid: false,
          data: [],
        },
        optstudent: {
          isValid: false,
          data: [],
        },
        cruise: {
          isValid: false,
          data: [],
        },
      },
      traveler: {
        immigrant: {
          isValid: false,
          data: [],
        },
        schengen: {
          isValid: false,
          data: [],
        },
        student: {
          isValid: false,
          data: [],
        },
        j1: {
          isValid: false,
          data: [],
        },
        visitor: {
          isValid: false,
          data: [],
        },
        trip: {
          isValid: false,
          data: [],
        },
        preex: {
          isValid: false,
          data: [],
        },
        addnd: {
          isValid: false,
          data: [],
        },
        medevac: {
          isValid: false,
          data: [],
        },
        optstudent: {
          isValid: false,
          data: [],
        },
        cruise: {
          isValid: false,
          data: [],
        },
      },
      coverage_dates: {
        immigrant: {
          isValid: false,
        },
        schengen: {
          isValid: false,
        },
        student: {
          isValid: false,
        },
        j1: {
          isValid: false,
        },
        visitor: {
          isValid: false,
        },
        trip: {
          isValid: false,
        },
        preex: {
          isValid: false,
          data: [],
        },
        addnd: {
          isValid: false,
          data: [],
        },
        medevac: {
          isValid: false,
          data: [],
        },
        optstudent: {
          isValid: false,
          data: [],
        },
        cruise: {
          isValid: false,
        },
      },
      quote_data: null,
    },
    // NOTE: use gen_bar_<x> actions to manipulate this.
    generator_bar: {
      // use this property to determine if a generator bar instance has been opened
      isActive: false,
      isLoading: false,
      data_reset_target: null, // country/traveler
      disableNextBtn: true,
      states: {
        onCountrySelect: false,
        onTravelerInfo: false,
        onDateSelect: false,
      },
      actions: {
        toPrev: null,
        toPrevLabel: null,
        toNext: null,
        toNextLabel: null,
        popupCloseOnNext: false,
      },
      selected_plan: null,
      // Data protection flags during critical navigation periods
      data_protection: {
        protect_user_data: false,
        navigation_in_progress: false,
        last_protection_time: null,
      },
    },
    compared_plans: [],
    quote_settings: null,
    iscfar_enabled: false,
    quote_result_version: null,
    quote_result_card_version: null,
    tooltips: [],
    luna_get_quotes: { details: null },
    quote_filters: null,
    quote_history: [],
  },
  getters: {
    source: (state) => state.source,
    quote_data: (state) => state.quote_data,
    quote_data_states: (state) => state.quote_data_states,
    quote_state_current_category: (state) =>
      state.quote_data_states.current_category,
    headerLoad: (state) => state.headerLoad,
    quote_category: (state) => state.currentCategory,
    quote_nav_prev_category: (state) => state.navigation_prev_category,
    quote_nav_next_category: (state) => state.navigation_next_category,
    quote_results: (state) => state.quote_results,
    quote_error: (state) => state.quote_error,
    generator_bar: (state) => state.generator_bar,
    bypass_restore_from_cookie: (state) => state.bypass_restore_from_cookie,
    generator_screen_actions: (state) => state.generator_bar.actions,
    generator_screen_next_btn_disabled: (state) =>
      state.generator_bar.disableNextBtn,
    quote_compared_plans: (state) => state.compared_plans,
    quote_data_cookie: (state) => state.quote_data_cookie,
    quote_cookie_expires: (state) => state.quote_data_expires,
    generator_bar_active: (state) => state.generator_bar.isActive,
    quote_settings: (state) => state.quote_settings,
    iscfar_enabled: (state) => state.iscfar_enabled,
    quote_result_version: (state) => state.quote_result_version,
    quote_result_card_version: (state) => state.quote_result_card_version,
    get_quote_tooltips: (state) => state.tooltips,
    luna_get_quotes_details: (state) => state.luna_get_quotes.details,
    get_quote_filters: (state) => state.quote_filters,
    get_quote_history: (state) => state.quote_history,
  },
  mutations: {
    set_source(state, source) {
      state.source = source;
    },
    quote_data_set(state, payload) {
      state.quote_data = payload;
    },
    quote_data_reset(state) {
      state.quote_data = {
        immigrant: {
          destination: "USA",
          destination_state: null,
          travelers: [],
          coverage_dates: {
            start_date: null,
            end_date: null,
          },
        },
        schengen: {
          destinations: [],
          travelers: [],
          coverage_dates: {
            start_date: null,
            end_date: null,
          },
        },
        student: {
          destination: null,
          destination_state: null,
          travelers: [],
          coverage_dates: {
            start_date: null,
            end_date: null,
          },
        },
        j1: {
          destination: null,
          destination_state: null,
          travelers: [],
          coverage_dates: {
            start_date: null,
            end_date: null,
          },
        },
        visitor: {
          destinations: [],
          travelers: [],
          coverage_dates: {
            start_date: null,
            end_date: null,
          },
        },
        trip: {
          destinations: [],
          travelers: [],
          coverage_dates: {
            start_date: null,
            end_date: null,
          },
          trip_deposit_date: null,
          total_trip_cost: null,
        },
        preex: {
          destinations: [],
          travelers: [],
          coverage_dates: {
            start_date: null,
            end_date: null,
          },
        },
        addnd: {
          destinations: [],
          travelers: [],
          coverage_dates: {
            start_date: null,
            end_date: null,
          },
        },
        medevac: {
          destinations: [],
          travelers: [],
          coverage_dates: {
            start_date: null,
            end_date: null,
          },
        },
        optstudent: {
          destination: "USA",
          destination_state: null,
          travelers: [],
          coverage_dates: {
            start_date: null,
            end_date: null,
          },
        },
        cruise: {
          destinations: [],
          travelers: [],
          coverage_dates: {
            start_date: null,
            end_date: null,
          },
          trip_deposit_date: null,
          total_trip_cost: null,
        },
        current_category: null,
        options: {
          skip_nav_away: false,
        },
      };
    },
    set_current_category(state, category) {
      state.currentCategory = category;
      state.quote_data.current_category = category;
    },
    set_header_load(state, load) {
      state.headerLoad = load;
    },
    quote_results_set(state, data) {
      state.navigation_prev_category = state.quote_results?.category;
      state.navigation_next_category = data?.category;
      state.quote_results = data;
      state.quote_results.isActiveFilter = state.quote_results?.quote_filters
        ?.filter_slugs
        ? Object.values(
            state.quote_results?.quote_filters?.filter_slugs
          ).includes(true)
        : false;
    },
    quote_result_err(state, err) {
      state.quote_error = err;
    },
    // use this mutation when transitioning between generator bar instance
    quote_data_set_transition(state, payload) {
      state.quote_data = payload;
      state.quote_data_states.quote_data = payload;
    },
    quote_state_set(state, payload) {
      state.quote_data_states = payload;
    },
    generator_bar(state, payload) {
      state.generator_bar = payload;
    },
    set_bypass_restore_from_cookie(state, payload) {
      state.bypass_restore_from_cookie = payload;
    },
    update_generator_screen_actions(state, payload) {
      state.generator_bar.actions = payload;
    },
    toggle_generator_screen_next_btn(state, disable) {
      state.generator_bar.disableNextBtn = disable;
    },
    compared_plans_set(state, v) {
      state.compared_plans = v;
    },
    generator_bar_clear_selected_plan(state) {
      state.generator_bar.selected_plan = null;
    },
    quote_settings_set(state, v) {
      state.quote_settings = v;
    },
    gen_bar_is_loading(state, loading) {
      state.generator_bar.isLoading = loading;
    },
    iscfar_enabled_set(state, v) {
      state.iscfar_enabled = v;
    },
    quote_result_version_set(state, v) {
      state.quote_result_version = v;
    },
    quote_result_card_version_set(state, v) {
      state.quote_result_card_version = v;
    },
    set_quote_tooltips(state, tooltips) {
      state.tooltips = tooltips;
    },
    set_luna_get_quotes_details(state, details) {
      state.luna_get_quotes.details = details;
    },
    init_quote_filters(state, init) {
      state.quote_filters = init;
    },
    set_quote_filters(state, v) {
      if (!state.quote_filters) {
        state.quote_filters = {};
      }
      state.quote_filters[v.category_id] = v.filters;
    },
    // Data protection mutations for preventing data loss during navigation
    set_data_protection(state, protect) {
      state.generator_bar.data_protection.protect_user_data = protect;
      state.generator_bar.data_protection.last_protection_time = protect
        ? Date.now()
        : null;
    },
    set_navigation_in_progress(state, inProgress) {
      state.generator_bar.data_protection.navigation_in_progress = inProgress;
    },
    quote_history_set(state, item) {
      state.quote_history.push({
        cat: item?.cat ?? null,
        payload: item.payload,
        quote: item?.response?.result?.eligible_plans,
        quoteId: item?.response?.result?.eligible_plans?.quoteId,
        promotion: item?.promotion ?? false,
        quote_url: item?.quote_url ?? null,
        filters: item?.filters ?? null,
      });
    },
  },
  actions: {
    // Quote sort localStorage management with single JSON key
    get_quote_sort_data({ state }, categoryId) {
      try {
        const stored = localStorage.getItem("quote_sort_data");
        const data = stored ? JSON.parse(stored) : {};
        const categoryData = data[categoryId] || {};
        return Promise.resolve({
          value: categoryData.value || 0,
          index: categoryData.index || 0,
        });
      } catch (error) {
        return Promise.resolve({
          value: 0,
          index: 0,
        });
      }
    },
    set_quote_sort({ state }, { categoryId, value, index }) {
      try {
        const stored = localStorage.getItem("quote_sort_data");
        const data = stored ? JSON.parse(stored) : {};

        data[categoryId] = { value, index };
        localStorage.setItem("quote_sort_data", JSON.stringify(data));
      } catch (error) {
        // If parsing fails, create new data object
        const data = { [categoryId]: { value, index } };
        localStorage.setItem("quote_sort_data", JSON.stringify(data));
      }
    },
    cleanup_legacy_quote_sort_keys({ state }) {
      // Clean up old keys without category specificity
      localStorage.removeItem("quote_filter_value");
      localStorage.removeItem("quote_filter_index");

      // Clean up individual category keys if they exist
      const keys = Object.keys(localStorage);
      keys.forEach((key) => {
        if (
          key.startsWith("quote_sort_value_") ||
          key.startsWith("quote_sort_index_")
        ) {
          localStorage.removeItem(key);
        }
      });
    },
    // NOTE: DO NOT DISPATCH THIS ACTION ON QUOTES
    // (Visitor) Dest: USA, Traveler citizenship & residence: USA
    // as bypass_restore_from_cookie WILL be set to false
    // and will allow QuoteFromCookie.restoreDataFromCookie()
    // to dispatch this action.
    generate_quote({ commit }) {
      return new Promise((resolve, reject) => {
        this.commit("set_bypass_restore_from_cookie", false);
        commit("quote_result_err", null);

        let cat = this.getters.quote_category;
        let tripCategories = ["trip-insurance", "cruise-insurance"];
        let qtype = tripCategories.includes(cat) ? "trip" : "visitor";
        let url = appendSourceToUrl(`/quote/generate/${qtype}`, qtype, this);
        let payload = getQuotePayload(cat, this);
        payload.front_end_call = true;
        const savedFilters = localStorage.getItem("quote_filters");
        if (savedFilters) {
          const parsedFilters = JSON.parse(savedFilters);
          if (
            parsedFilters &&
            typeof parsedFilters === "object" &&
            parsedFilters.hasOwnProperty(payload.category_id)
          ) {
            payload.filters = parsedFilters[payload.category_id];
          }
        }

        let quote_filters = new QuoteFilterPayload();
        quote_filters.is_trip = qtype == "trip";
        quote_filters.category_id = payload.category_id;
        quote_filters.filter.filter_slugs = payload.filters?.filter_slugs ?? {};
        quote_filters.filter.coverage.id = payload?.filters?.coverage.id;
        quote_filters.filter.coverage.amount =
          payload?.filters?.coverage.amount;
        quote_filters.filter.sortOption = payload?.filters?.sortOption;

        this._vm.$http
          .post(url, payload)
          .then((res) => {
            if (res.data.result?.success && res.data.result?.success == true) {
              quote_filters.quote_id = res.data.result?.eligible_plans?.quoteId;
              quote_filters.filter.planSelections =
                res.data.result?.eligible_plans?.quote_filters?.planSelections;

              // Initialize plan selections in eligible plans
              if (res.data.result?.eligible_plans?.quote) {
                res.data.result.eligible_plans.quote.forEach((plan) => {
                  const planSelection =
                    quote_filters.filter.planSelections?.[plan.api_plan_name];

                  if (planSelection?.policy_max?.amount > -1)
                    plan.selected_policy_max = planSelection.policy_max.amount;

                  if (planSelection?.deductible?.amount > -1)
                    plan.selected_deductible = planSelection.deductible.amount;
                });
              }

              commit("init_quote_filters", quote_filters);
              commit("quote_results_set", res.data.result.eligible_plans);
              commit(
                "iscfar_enabled_set",
                res.data.result.eligible_plans?.iscfar_enabled
              );
              commit("set_quote_tooltips", res.data.result.tooltips);
              commit("quote_history_set", {
                cat: cat,
                payload: payload,
                response: res.data,
                promotion: false,
                quote_url: null,
                filters: quote_filters,
              });
              resolve(res.data.result.eligible_plans);
            } else {
              let err = res.data.error ? res.data.error : "Invalid Response";
              commit("quote_result_err", err);
              reject(err);
            }
          })
          .catch((err) => {
            commit("quote_result_err", err);
            reject(err);
          })
          .finally(() => {
            commit("wizard_loading_set", false);
          });
      });
    },
    quote_plan_premium({ _ }, payload) {
      return new Promise((resolve, reject) => {
        let cat = this.getters.quote_category;
        let tripCategories = ["trip-insurance", "cruise-insurance"];
        let qtype = tripCategories.includes(cat) ? "trip" : "visitor";
        let url = `/quote/premium/${qtype}`;
        this._vm.$http
          .post(url, payload)
          .then((res) => {
            if (res.data.result?.success && res.data.result?.success == true) {
              resolve(res.data.result);
            } else {
              let err = res.data.error ? res.data.error : "Invalid Response";
              reject(err);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    quote_plan_vendor_premium({ _ }, payload) {
      return new Promise((resolve, reject) => {
        let cat = this.getters.quote_category;
        let tripCategories = ["trip-insurance", "cruise-insurance"];
        let qtype = tripCategories.includes(cat) ? "trip" : "visitor";
        let url = `/quote/vendorPremium/${qtype}`;
        this._vm.$http
          .post(url, payload)
          .then((res) => {
            if (res.data.result?.success && res.data.result?.success == true) {
              resolve(res.data.result);
            } else {
              let err = res.data.error ? res.data.error : "Invalid Response";
              reject(err);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    email_quote({ _ }, data) {
      return new Promise((resolve, reject) => {
        let tripCategories = [15, 32];
        let plan_type = tripCategories.includes(data.categoryID)
          ? "trip"
          : "visitor";
        let payload = { email: data.email };
        if (data?.params) payload.params = data.params;

        let url = `/quote/email/${plan_type}/${data.quoteID}`;
        this._vm.$http
          .post(url, payload)
          .then((res) => {
            if (res && res.data.success == true) {
              resolve(res.data);
            } else {
              reject("Invalid Response");
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    restore_quote_by_id({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        let qtype = payload.isVisitor ? "visitor" : "trip";
        let filter_data = payload?.filter_data ? payload.filter_data : false;
        let url = `/quote/restore/${qtype}/${payload.quoteId}`;
        if (filter_data) {
          url += "/" + payload.filter_data;
        }
        url = appendSourceToUrl(url, qtype, this);

        let quote_filters = new QuoteFilterPayload();
        quote_filters.is_trip = qtype == "trip";

        this._vm.$http
          .get(url)
          .then((res) => {
            if (res.data.result?.success && res.data.result?.success == true) {
              quote_filters.category_id =
                res.data.result?.eligible_plans?.category?.category_id;
              quote_filters.filter.filter_slugs =
                res.data.result?.eligible_plans?.quote_filters?.filter_slugs;
              quote_filters.filter.coverage.id =
                res.data.result?.eligible_plans?.quote_filters?.coverage?.id;
              quote_filters.filter.coverage.amount =
                res.data.result?.eligible_plans?.quote_filters?.coverage?.amount;
              quote_filters.filter.sortOption =
                res.data.result?.eligible_plans?.quote_filters?.sortOption;
              quote_filters.filter.planSelections =
                res.data.result?.eligible_plans?.quote_filters?.planSelections;

              if (res.data.request?.category_id) {
                quoteDataRestore(state, res.data.request);
              }

              // Initialize plan selections in eligible plans
              if (res.data.result?.eligible_plans?.quote) {
                res.data.result.eligible_plans.quote.forEach((plan) => {
                  const planSelection =
                    quote_filters.filter.planSelections?.[plan.api_plan_name];

                  if (planSelection?.policy_max?.amount > -1)
                    plan.selected_policy_max = planSelection.policy_max.amount;

                  if (planSelection?.deductible?.amount > -1)
                    plan.selected_deductible = planSelection.deductible.amount;
                });
              }

              commit("init_quote_filters", quote_filters);
              commit("quote_results_set", res.data.result.eligible_plans);
              commit("set_quote_tooltips", res.data.result.tooltips);
              resolve(res.data.result.eligible_plans);
            } else {
              let err = res.data.error ? res.data.error : "Invalid Response";
              reject(err);
            }
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            commit("wizard_loading_set", false);
          });
      });
    },
    save_quote_filters({ commit }, payload) {
      return new Promise((resolve, reject) => {
        let qtype = payload.is_trip ? "trip" : "visitor";
        let url = `/quote/saveFilters/${qtype}`;
        this._vm.$http
          .post(url, payload)
          .then((res) => {
            if (res?.data.result?.success) {
              commit("set_quote_filters", payload);
              resolve(res.data.result.quote_id);
            } else {
              reject("Failed to save filters");
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // START - Immigrant data states
    quote_state_immigrant_dest_data({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.IMMIGRANT.TYPE;
      state.quote_data_states.destination.immigrant = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    quote_state_immigrant_trav_data({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.IMMIGRANT.TYPE;
      state.quote_data_states.traveler.immigrant = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    quote_state_immigrant_cov_validity({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.IMMIGRANT.TYPE;
      state.quote_data_states.coverage_dates.immigrant.isValid = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    // END - Immigrant data states
    // START - J1 data states
    quote_state_j1_dest_data({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.J1.TYPE;
      state.quote_data_states.destination.j1 = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    quote_state_j1_trav_data({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.J1.TYPE;
      state.quote_data_states.traveler.j1 = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    quote_state_j1_cov_validity({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.J1.TYPE;
      state.quote_data_states.coverage_dates.j1.isValid = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    // END - J1 data states
    // START - Schengen data states
    quote_state_schengen_dest_data({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.SCHENGEN.TYPE;
      state.quote_data_states.destination.schengen = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    quote_state_schengen_trav_data({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.SCHENGEN.TYPE;
      state.quote_data_states.traveler.schengen = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    quote_state_schengen_cov_validity({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.SCHENGEN.TYPE;
      state.quote_data_states.coverage_dates.schengen.isValid = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    // END - Schengen data states
    // START - Student data states
    quote_state_student_dest_data({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.STUDENT.TYPE;
      state.quote_data_states.destination.student = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    quote_state_student_trav_data({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.STUDENT.TYPE;
      state.quote_data_states.traveler.student = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    quote_state_student_cov_validity({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.STUDENT.TYPE;
      state.quote_data_states.coverage_dates.student.isValid = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    // END - Student data states
    // START - Trip data states
    quote_state_trip_dest_data({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.TRIP.TYPE;
      state.quote_data_states.destination.trip = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    quote_state_trip_trav_data({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.TRIP.TYPE;
      state.quote_data_states.traveler.trip = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    quote_state_trip_cov_validity({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.TRIP.TYPE;
      state.quote_data_states.coverage_dates.trip.isValid = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    // END - Trip data states
    // START - Visitor data states
    quote_state_visitor_dest_data({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.VISITOR.TYPE;
      state.quote_data_states.destination.visitor = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    quote_state_visitor_trav_data({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.VISITOR.TYPE;
      state.quote_data_states.traveler.visitor = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    quote_state_visitor_cov_validity({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.VISITOR.TYPE;
      state.quote_data_states.coverage_dates.visitor.isValid = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    // END - Visitor data states
    // START - preex data states
    quote_state_preex_dest_data({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.PREEX.TYPE;
      state.quote_data_states.destination.preex = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    quote_state_preex_trav_data({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.PREEX.TYPE;
      state.quote_data_states.traveler.preex = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    quote_state_preex_cov_validity({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.PREEX.TYPE;
      state.quote_data_states.coverage_dates.preex.isValid = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    // END - preex data states
    // START - Addnd data states
    quote_state_addnd_dest_data({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.ADDND.TYPE;
      state.quote_data_states.destination.addnd = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    quote_state_addnd_trav_data({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.ADDND.TYPE;
      state.quote_data_states.traveler.addnd = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    quote_state_addnd_cov_validity({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.ADDND.TYPE;
      state.quote_data_states.coverage_dates.addnd.isValid = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    // END - addnd data states
    // START - optstudent data states
    quote_state_optstudent_dest_data({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.OPTSTUDENT.TYPE;
      state.quote_data_states.destination.optstudent = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    quote_state_optstudent_trav_data({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.OPTSTUDENT.TYPE;
      state.quote_data_states.traveler.optstudent = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    quote_state_optstudent_cov_validity({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.OPTSTUDENT.TYPE;
      state.quote_data_states.coverage_dates.optstudent.isValid = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    // END - optstudent data states
    // START - medevac data states
    quote_state_medevac_dest_data({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.MEDEVAC.TYPE;
      state.quote_data_states.destination.medevac = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    quote_state_medevac_trav_data({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.MEDEVAC.TYPE;
      state.quote_data_states.traveler.medevac = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    quote_state_medevac_cov_validity({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.MEDEVAC.TYPE;
      state.quote_data_states.coverage_dates.medevac.isValid = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    // END - medevac data states
    // START - Cruise data states
    quote_state_cruise_dest_data({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.CRUISE.TYPE;
      state.quote_data_states.destination.cruise = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    quote_state_cruise_trav_data({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.CRUISE.TYPE;
      state.quote_data_states.traveler.cruise = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    quote_state_cruise_cov_validity({ commit, state }, payload) {
      state.quote_data_states.current_category = PlanCategories.CRUISE.TYPE;
      state.quote_data_states.coverage_dates.cruise.isValid = payload;
      commit("quote_state_set", state.quote_data_states);
    },
    // END - CRUISE data states
    gen_bar_close_country_sel_popup({ commit, state }) {
      state.generator_bar.data_reset_target = "country";
      this.dispatch("gen_bar_close_popups");
    },
    gen_bar_close_traveler_info_popup({ commit, state }) {
      state.generator_bar.data_reset_target = "traveler";
      this.dispatch("gen_bar_close_popups");
    },
    gen_bar_close_popups({ commit, state }) {
      let genBar = state.generator_bar;
      resetGenBarStates(genBar);
      unbindActions(genBar);
      quoteDataReset(state);
      commit("generator_bar", genBar);
    },
    gen_bar_move_country_sel({ commit, state }, plan = null) {
      let genBar = state.generator_bar;
      resetGenBarStates(genBar);
      genBar.isActive = true;
      genBar.states.onCountrySelect = true;
      genBar.selected_plan = plan;
      commit("generator_bar", genBar);
    },
    gen_bar_move_trav_info({ commit, state }) {
      let genBar = state.generator_bar;
      resetGenBarStates(genBar);
      genBar.isActive = true;
      genBar.states.onTravelerInfo = true;
      commit("generator_bar", genBar);
    },
    gen_bar_move_date_sel({ commit, state }) {
      let genBar = state.generator_bar;
      resetGenBarStates(genBar);
      genBar.isActive = true;
      genBar.states.onDateSelect = true;
      commit("generator_bar", genBar);
    },
    gen_bar_close_date_sel({ commit, state }) {
      let genBar = state.generator_bar;
      resetGenBarStates(genBar);
      genBar.isActive = true;
      genBar.states.onDateSelect = false;
      commit("generator_bar", genBar);
    },
    gen_bar_reset({ commit, state }) {
      let genBar = state.generator_bar;
      resetGenBarStates(genBar);
      genBar.isActive = false;
      commit("generator_bar", genBar);
    },
    // For instances where generator bar doesn't open
    // any of the screens (check generator_bar.states)
    // or on close event
    gen_bar_toggle({ commit, state }, payload) {
      state.generator_bar.isActive = payload;
      commit("generator_bar", state.generator_bar);
    },
    set_quote_category_type_by_id({ commit }, category_id) {
      let cat = PlanCategories.VISITOR.TYPE;
      Object.keys(PlanCategories).forEach((c) => {
        if (PlanCategories[c].ID == category_id) cat = PlanCategories[c].TYPE;
      });
      commit("set_current_category", cat);
    },
    set_compared_plans({ commit }, v) {
      commit("compared_plans_set", v);
    },
    set_quote_category_type_by_url({ commit, state }, payload) {
      var category_url = payload.path.replace(/^\/+|\/+$/g, "");
      let cat = PlanCategories.VISITOR.TYPE;
      Object.keys(PlanCategories).forEach((c) => {
        var quote_url = PlanCategories[c]?.QUOTE.replace(/^\/+|\/+$/g, "");
        if (quote_url == category_url) cat = PlanCategories[c].TYPE;
      });
      let qdCk = state.quote_data_cookie;
      let Qdata = $cookies.get(qdCk);
      // console.log(Qdata);
      Qdata.current_category = cat;
      Qdata.iscfar_enabled = state?.iscfar_enabled;
      $cookies.set(
        state.quote_data_cookie,
        JSON.stringify(Qdata),
        state.quote_data_expires
      );
      commit("set_current_category", cat);
    },
    quote_results_set_action({ commit }, data) {
      commit("quote_results_set", data);
    },
    quote_result_err_action({ commit }, err) {
      commit("quote_result_err", err);
    },
    quote_get_settings({ commit }) {
      return new Promise((resolve, reject) => {
        let url = `/quote/settings/`;
        this._vm.$http
          .get(url)
          .then((res) => {
            if (
              res.data?.success &&
              res.data?.success == true &&
              res.data?.settings
            ) {
              commit("quote_settings_set", res.data.settings);
              resolve(res.data.settings);
            } else {
              let err = res.data.error ? res.data.error : "Invalid Response";
              reject(err);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    quote_history_add_new_item({ commit }, item) {
      commit("quote_history_set", item);
    },
    convertDobToAgeAndUpdate({ commit, state }, { storeKey, travelers }) {
      const moment = this._vm.$moment;
      let dobConverted = false;

      const convertedTravelers = travelers.map((traveler) => {
        if (!traveler.age && traveler.dob) {
          try {
            const dobMoment = moment(traveler.dob, [
              "MM/DD/YYYY",
              "YYYY-MM-DD",
              "DD/MM/YYYY",
            ]);
            if (dobMoment.isValid()) {
              const age = moment().diff(dobMoment, "years");
              dobConverted = true;
              return { ...traveler, age, dob: null };
            }
          } catch (error) {
            console.error("Error calculating age from DOB:", error);
          }
        }
        return traveler;
      });

      if (dobConverted) {
        let currentData = JSON.parse(JSON.stringify(state.quote_data));
        currentData[storeKey].travelers = convertedTravelers;
        commit("quote_data_set", currentData);
      }

      return { travelers: convertedTravelers, dobConverted };
    },
  },
};

export { quoteModule };
